import React from 'react'
import { Button, Icon } from 'semantic-ui-react'

/**
 * Convierte el texto plano del asistente en nodos React sin HTML crudo:
 * lineas que empiezan con "- " se agrupan en listas y **texto** se resalta.
 */
function formatearInline(texto, claveBase) {
    const partes = texto.split(/(\*\*[^*]+\*\*)/g)
    return partes.map((parte, i) => {
        if (parte.startsWith('**') && parte.endsWith('**') && parte.length > 4) {
            return <strong key={`${claveBase}-${i}`}>{parte.slice(2, -2)}</strong>
        }
        return <React.Fragment key={`${claveBase}-${i}`}>{parte}</React.Fragment>
    })
}

export function formatearTexto(texto) {
    const lineas = (texto || '').split('\n')
    const nodos = []
    let items = []

    const cerrarLista = () => {
        if (items.length) {
            nodos.push(
                <ul key={`ul-${nodos.length}`}>
                    {items.map((item, i) => <li key={i}>{formatearInline(item, `li-${nodos.length}-${i}`)}</li>)}
                </ul>
            )
            items = []
        }
    }

    lineas.forEach((linea, i) => {
        const esItem = /^\s*[-•]\s+/.test(linea)
        if (esItem) {
            items.push(linea.replace(/^\s*[-•]\s+/, ''))
            return
        }
        cerrarLista()
        if (linea.trim() === '') return
        nodos.push(<p key={`p-${i}`}>{formatearInline(linea, `p-${i}`)}</p>)
    })
    cerrarLista()
    return nodos
}

export function MensajeChat({ mensaje, onNavegar, onReintentar, cargando }) {
    const esUsuario = mensaje.rol === 'usuario'
    const clase = [
        'chat-mensaje',
        esUsuario ? 'chat-mensaje--usuario' : 'chat-mensaje--asistente',
        mensaje.error ? 'chat-mensaje--error' : ''
    ].join(' ')

    return (
        <div className={clase}>
            <div className="chat-mensaje__burbuja">
                {mensaje.error && <Icon name='warning sign' />}
                {esUsuario
                    ? <p>{mensaje.contenido}</p>
                    : formatearTexto(mensaje.contenido)}

                {mensaje.error && (
                    <Button
                        basic
                        size='mini'
                        icon='redo'
                        content='Reintentar'
                        disabled={cargando}
                        onClick={() => onReintentar(mensaje.id)}
                        className="chat-mensaje__reintentar"
                    />
                )}
            </div>

            {!esUsuario && mensaje.enlaces && mensaje.enlaces.length > 0 && (
                <div className="chat-mensaje__enlaces">
                    {mensaje.enlaces.map(enlace => (
                        <button
                            type="button"
                            key={enlace.ruta}
                            className="chat-mensaje__enlace"
                            onClick={() => onNavegar(enlace.ruta)}
                            title={enlace.ruta}
                        >
                            <Icon name='external' />
                            <span>{enlace.titulo}</span>
                        </button>
                    ))}
                </div>
            )}

            {!esUsuario && mensaje.herramientas && mensaje.herramientas.length > 0 && (
                <div className="chat-mensaje__fuentes">
                    Consulté: {[...new Set(mensaje.herramientas.map(h => h.etiqueta))].join(' · ')}
                </div>
            )}
        </div>
    )
}
